module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask confirm"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n            " + _vm._s(_vm.body) + "\n            "), _c('br'), _vm._v(" "), (!_vm.onlyClose) ? _c('span', {
    staticClass: "blue-text"
  }, [_vm._v(_vm._s(_vm.data.firstname) + " " + _vm._s(_vm.data.lastname))]) : _vm._e(), _vm._v(" "), (!_vm.onlyClose) ? _c('span', [_vm._v("?")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button grey-button btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Annuler\n            ")]), _vm._v(" "), (!_vm.onlyClose) ? _c('button', {
    staticClass: "modal-default-button green-button btn btn-primary",
    on: {
      "click": function($event) {
        _vm.$emit('confirm')
      }
    }
  }, [_vm._v("Valider\n            ")]) : _vm._e()])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-298c90ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ModalConfirm.vue
// module id = 1808
// module chunks = 2